import type { Catalog } from "@/data/catalog";

/**
 * A preparation may only enter the deduplication cache after the catalog
 * proves the performance exists. Cold deep links render before catalog
 * bootstrap completes; caching that early no-op would prevent the route from
 * retrying once its performance becomes available.
 */
export function canCachePerformancePreparation(
  catalog: Catalog | null,
  performanceId: string
): boolean {
  return Boolean(
    performanceId &&
      catalog?.performances.some(
        (performance) => performance.performanceId === performanceId
      )
  );
}
